import { render, staticRenderFns } from "./AddKeywords.vue?vue&type=template&id=d29c47ba&"
import script from "./AddKeywords.vue?vue&type=script&lang=ts&"
export * from "./AddKeywords.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports